<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <!-- align-center -->
      <v-flex text-xs-center>
        <template>
          <!-- filtrado -->
          <v-card dark>
            <v-layout row wrap px-3 small-inputs>
              <v-flex xs12 sm2 px-1>
                <!-- hide-details -->
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Buscar paciente"
                  hint="IDPaciente / Nombre"
                  clearable
                  single-line
                  persistent-hint
                ></v-text-field>
                <!-- @input="filterSearch" -->
              </v-flex>
              <!-- search -->

              <v-flex xs12 sm1 px-1>
                <v-select
                  v-model="mod"
                  :items="mods"
                  item-text="sigla"
                  item-value="sigla"
                  prepend-icon="check_box"
                  label="Mod"
                  return-object
                  multiple
                ></v-select>
                <!-- @change="filterMods" -->
              </v-flex>
              <!-- mod -->

              <v-flex xs12 sm2 px-1>
                <v-menu
                  ref="menuStartDate"
                  v-model="menuStartDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="startDateFormattedMomment"
                      clearable
                      readonly
                      label="Desde"
                      prepend-icon="event"
                      v-on="on"
                      @click:clear="filterStartDate(null)"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title></v-date-picker>
                  <!-- @input="filterStartDate" -->
                </v-menu>
              </v-flex>
              <!-- startDate -->

              <v-flex xs12 sm2 px-1>
                <v-menu
                  ref="menuEndDate"
                  v-model="menuEndDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="endDateFormattedMomment"
                      clearable
                      readonly
                      label="Hasta"
                      prepend-icon="event"
                      v-on="on"
                      @click:clear="filterEndDate(null)"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="endDate" no-title></v-date-picker>
                  <!-- @input="filterEndDate" -->
                </v-menu>
              </v-flex>
              <!-- endDate -->

              <v-flex xs12 sm2 px-1>
                <v-select
                  v-model="doctor"
                  :items="doctors"
                  item-text="nombre_completo"
                  item-value="nombre_completo"
                  prepend-icon="check_box"
                  label="Radiólogos"
                  :disabled="disabledoctors"
                  return-object
                  multiple
                ></v-select>
                <!-- @change="filterDoctors" -->
              </v-flex>
              <!-- doctor -->

              <v-flex xs12 sm2 px-1>
                <v-select
                  v-model="state"
                  :items="states"
                  item-text="nombre_estado"
                  item-value="id_estado"
                  prepend-icon="check_box"
                  label="Estado"
                  return-object
                  multiple
                ></v-select>
                <!-- @change="filterStates" -->
              </v-flex>
              <!-- state -->

              <v-flex xs12 sm1 px-1>
                <v-select
                  v-model="institution"
                  :items="institutions"
                  item-text="nombre_institucion"
                  item-value="id_institucion"
                  prepend-icon="check_box"
                  label="Ins."
                  return-object
                  multiple
                ></v-select>
                <!-- @change="filterInstitutions" -->
              </v-flex>
              <!-- institution -->
            </v-layout>
            <v-layout row wrap px-3 small-inputs>
              <v-flex xs12>
                <v-btn small block color="accent" @click="getData(true)"
                  >Burcar</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card>
        </template>

        <template>
          <!-- exámenes -->
          <v-card>
            <v-card-title>
              <div class="title">{{ pagename }}</div>
              <v-spacer></v-spacer>
              <!-- <v-btn color="warning" dark @click="loadValidates" :loading="loadingExams">Cargar Validados</v-btn> -->
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="accent"
                    dark
                    @click="initialize"
                    :loading="loadingExams"
                    v-on="on"
                  >
                    <v-icon dark>refresh</v-icon>
                  </v-btn>
                </template>
                <span>Recargar listado de exámenes</span>
              </v-tooltip>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="desserts"
              class="elevation-1"
              :pagination.sync="pagination"
              :total-items="totalDesserts"
              :rows-per-page-items="rowsPerPageItems"
              :loading="loadingExams"
              :hide-actions="loadingExams"
            >
              <template v-slot:items="props">
                <tr></tr>
                <tr
                  @contextmenu.prevent="
                    $refs.menuExam.open($event, { item: props.item })
                  "
                >
                  <td>
                    <span
                      v-if="props.item.condicion == 1"
                      class="badge rounded green"
                    ></span>
                    <span
                      v-else-if="props.item.condicion == 2"
                      class="badge rounded amber"
                    ></span>
                    <span
                      v-else-if="props.item.condicion == 3"
                      class="badge rounded red"
                    ></span>
                  </td>
                  <td class="px-2">{{ props.item.numero_archivos }}</td>
                  <td class="px-2">
                    {{ formatDate(props.item.fecha_hora_examen) }}
                  </td>
                  <td class="text-xs-left px-2">{{ props.item.alive }}</td>
                  <td class="text-xs-left px-2">{{ props.item.IDPaciente }}</td>
                  <td class="text-no-wrap text-xs-left px-2">
                    {{ props.item.nombre }}
                  </td>
                  <td class="text-xs-left px-2">{{ props.item.edad }}</td>
                  <!-- <td class="text-xs-left px-2">{{ props.item.correo_paciente }}</td> -->
                  <td class="text-xs-left px-2">{{ props.item.modalidad }}</td>
                  <td class="text-no-wrap text-xs-left px-2">
                    {{ props.item.login }}
                  </td>
                  <td class="text-xs-left px-2">
                    {{ props.item.institucion }}
                  </td>
                  <td class="text-xs-left px-2">
                    {{ props.item.nombre_estado }}
                  </td>
                  <td class="layout px-0">
                    <!-- Acciones -->
                    <v-btn
                      flat
                      icon
                      title="Editar exámen"
                      class="mx-0"
                      @click="editItem(props.item)"
                    >
                      <v-icon color="accent">edit</v-icon>
                    </v-btn>
                    <!-- editar -->

                    <v-btn
                      flat
                      icon
                      title="Ver orden médica"
                      color="accent"
                      class="mx-0"
                      @click="viewImage(props.item, 'orden')"
                      :disabled="
                        props.item.archivos.filter(
                          (file) => file.tipo == 'orden'
                        ).length == 0
                      "
                    >
                      <v-icon>attachment</v-icon>
                    </v-btn>
                    <!-- ver orden médica -->

                    <v-btn
                      flat
                      icon
                      title="Ver imágenes"
                      color="accent"
                      class="mx-0"
                      :href="'/' + typeViewer + '/' + props.item.id + '/dcm'"
                      target="_blank"
                    >
                      <v-icon>photo_library</v-icon>
                    </v-btn>
                    <!-- ver imagenes -->

                    <v-btn
                      flat
                      icon
                      title="Informar examen"
                      color="accent"
                      class="mx-0"
                      @click="selectPrestations(props.item)"
                      :disabled="
                        props.item.id_estado == 1 || props.item.id_estado == 4
                      "
                    >
                      <v-icon>assignment</v-icon>
                    </v-btn>
                    <!-- informar examen -->

                    <v-btn
                      flat
                      icon
                      title="Enviar email"
                      color="accent"
                      class="mx-0"
                      @click="selectReportEmail(props.item)"
                    >
                      <v-icon>email</v-icon>
                    </v-btn>
                    <!-- :disabled="props.item.id_estado == 1" -->
                    <!-- enviar mail -->

                    <v-btn
                      flat
                      icon
                      title="Ver Informe"
                      color="accent"
                      class="mx-0"
                      @click="selectReportView(props.item)"
                      :disabled="
                        props.item.id_estado != 4 && props.item.id_estado != 5
                      "
                    >
                      <v-icon>picture_as_pdf</v-icon>
                    </v-btn>
                    <!-- ver informe -->

                    <v-btn
                      flat
                      icon
                      title="Reabrir informe"
                      color="accent"
                      class="mx-0"
                      :disabled="
                        props.item.id_estado != 4 && props.item.id_estado != 5
                      "
                      @click="selectReportReopen(props.item)"
                    >
                      <v-icon>assignment_late</v-icon>
                    </v-btn>
                    <!-- reabrir informe -->

                    <v-badge overlap class="d-inline-flex" color="success">
                      <template
                        v-if="props.item.comentarios.length > 0"
                        v-slot:badge
                      >
                        <span>{{ props.item.comentarios.length }}</span>
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Comentar exámen"
                        color="accent"
                        class="mx-0"
                        @click="commentItem(props.item, props.index)"
                      >
                        <v-icon>chat</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge overlap class="d-inline-flex" color="transparent">
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveDcm ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >JPG</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar imágenes"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveDcm"
                        @click="downloadZip(props.item, 'dcm')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge overlap class="d-inline-flex" color="transparent">
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveOtrodcm ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >DCM</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar DCM"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveOtrodcm"
                        @click="downloadZip(props.item, 'otrodcm')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge overlap class="d-inline-flex" color="transparent">
                      <template v-slot:badge>
                        <v-icon
                          :class="
                            (!props.item.haveMod ? 'disabled ' : '') +
                              'accent--text'
                          "
                          >photo_camera</v-icon
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar fotografías y modelos"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveMod"
                        @click="downloadZip(props.item, 'mod')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>

                    <v-badge overlap class="d-inline-flex" color="transparent">
                      <template v-slot:badge>
                        <span
                          :class="
                            (!props.item.haveStl ? 'disabled ' : '') +
                              'badge-text accent--text'
                          "
                          >STL</span
                        >
                      </template>
                      <v-btn
                        flat
                        icon
                        title="Descargar modelos STL"
                        color="accent"
                        class="mx-0"
                        :disabled="!props.item.haveStl"
                        @click="downloadZip(props.item, 'stl')"
                      >
                        <v-icon>save_alt</v-icon>
                      </v-btn>
                    </v-badge>
                  </td>
                </tr>
              </template>

              <template v-slot:no-data>
                <v-alert
                  :value="!loadingExams"
                  color="error"
                  icon="warning"
                  transition="scale-transition"
                >
                  Lo sentimos, no se encontraron registros para la búsqueda.
                </v-alert>
                <v-alert
                  :value="loadingExams"
                  color="info"
                  icon="manage_search"
                  transition="scale-transition"
                >
                  Estamos trabajando para encontrar los registros de su
                  búsqueda.
                </v-alert>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>

              <template v-slot:no-results>
                <v-alert
                  :value="!loadingExams"
                  color="error"
                  icon="warning"
                  transition="scale-transition"
                >
                  Lo sentimos, no se encontraron registros para la búsqueda.
                </v-alert>
                <v-alert
                  :value="loadingExams"
                  color="amber darken-2"
                  icon="manage_search"
                  transition="scale-transition"
                >
                  Seguimos trabajando para encontrar los registros de su
                  búsqueda.
                </v-alert>
              </template>
            </v-data-table>
          </v-card>
        </template>

        <template>
          <!-- viewer -->
          <v-container d-none grid-list-sm fluid>
            <v-layout
              row
              wrap
              v-viewer="viewerOptions"
              class="viewer"
              ref="viewer"
            >
              <figure v-for="(image, index) in images" :key="index">
                <img
                  class="responsive-img"
                  :src="image.src"
                  :data-source="image.src"
                  alt="Imagen DCM"
                  width="200"
                />
              </figure>
            </v-layout>
          </v-container>
        </template>

        <v-dialog v-model="dialogComments" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Comentarios</v-card-title
            >
            <v-card-text>
              <v-list
                v-if="comments.length > 0"
                three-line
                style="height: 250px; overflow-y: scroll;"
              >
                <template v-for="(item, index) in comments">
                  <v-list-tile :key="index">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ item.nombre_autor }}
                        <span class="caption grey--text text--lighten-1"
                          >({{ item.correo_autor + " - " + item.alive }})</span
                        >
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="item.comentario"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider :key="index"></v-divider>
                </template>
              </v-list>
              <v-alert v-else :value="true" type="warning"
                >Sin comentarios por ahora.</v-alert
              >
              <v-divider dark class="my-3"></v-divider>
              <!-- prepend-icon="comment" -->
              <v-textarea
                box
                v-model="newComment"
                label="Agregar comentario"
                background-color="secondary"
                color="primary"
                :loading="loadingComment"
                :readonly="loadingComment"
                autofocus
                counter
              ></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" flat @click="dialogComments = false"
                >Cerrar</v-btn
              >
              <v-btn
                color="primary darken-1"
                @click="comentarExamen"
                :disabled="newComment.length === 0"
                :loading="loadingComment"
                >Comentar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogInformar" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Prestaciones a Informar</v-card-title
            >
            <v-card-text>
              <template
                v-for="(prestacion, index, key) in informarPrestaciones"
              >
                <v-checkbox
                  :key="key"
                  v-model="prestacionesSelected"
                  :label="prestacion.nombre_prestacion"
                  :value="prestacion.id_prestacion"
                  multiple
                ></v-checkbox>
              </template>

              <v-alert :value="informarPrestaciones.length == 0" type="info"
                >Todos los informes de este exámen han sido validados.</v-alert
              >

              <template v-if="informes.length > 0">
                <v-divider></v-divider>
                <div class="subheading">Informado</div>
                <template v-for="(informe, index, key) in informes">
                  <v-btn
                    color="primary"
                    class="d-block text-xs-left"
                    :to="{
                      name: 'ExamReport',
                      params: { id_examen: examSelected.id },
                      query: { id_informe: informe.id_informe },
                    }"
                    :key="key"
                    flat
                    small
                    >{{ informe.nombre }}</v-btn
                  >
                </template>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" flat @click="dialogInformar = false"
                >Cerrar</v-btn
              >
              <v-btn
                color="primary darken-1"
                @click="reportItem({ prestaciones: prestacionesSelected })"
                :disabled="prestacionesSelected.length === 0"
                >Informar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogVerInforme" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Ver Informe</v-card-title
            >
            <v-card-text>
              <template v-for="(informe, index, key) in informesValidados">
                <v-btn flat @click="viewReport(informe)" :key="key">{{
                  informe.nombre
                }}</v-btn>
              </template>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="gray darken-1"
                flat
                @click="dialogVerInforme = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogReabrirInforme" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Reabrir Informe</v-card-title
            >
            <v-card-text>
              <v-combobox
                :items="informesValidados"
                v-model="reportSelected"
                item-text="nombre"
                item-value="id_informe"
                label="Seleccione informe a reabrir"
                return-object
                auto-select-first
              ></v-combobox>

              <v-textarea
                box
                v-model="commentReopen"
                label="Motivo de corrección"
                background-color="tertiary"
                :loading="loadingComment"
                :readonly="loadingComment"
                autofocus
                counter
              ></v-textarea>

              <v-divider dark class="my-3"></v-divider>

              <v-btn primary flat small right @click="getComentariosReabrir"
                >Ver historial de reaperturas</v-btn
              >

              <v-list
                v-if="comentariosReabrir.length > 0"
                three-line
                style="height: 250px; overflow-y: scroll;"
              >
                <template v-for="(item, index, key) in comentariosReabrir">
                  <v-list-tile :key="key">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ item.autor }}
                        <span class="caption grey--text text--lighten-1"
                          >({{ item.correo + " - " + item.alive }})</span
                        >
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-html="item.comentario"
                      ></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider :key="index"></v-divider>
                </template>
              </v-list>

              <!-- <v-alert
                v-else
                :value="true"
                type="warning"
              >
                Sin comentarios por ahora.
              </v-alert>-->
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="gray darken-1"
                flat
                @click="dialogReabrirInforme = false"
                >Cerrar</v-btn
              >
              <v-btn color="primary darken-1" @click="reOpenReport"
                >Apertura Informe</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEmail" persistent>
          <v-card>
            <v-card-title class="headline primary white--text"
              >Enviar Informe por Email</v-card-title
            >
            <v-card-text>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs12 px-1>
                    <v-combobox
                      :items="informesValidados"
                      v-model="reportSelected"
                      item-text="nombre"
                      item-value="id_informe"
                      label="Seleccione informe a enviar"
                      return-object
                      auto-select-first
                    >
                      <template v-slot:no-data>
                        <span>Sin informes que adjuntar.</span>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-flex xs12 sm6 px-1>
                    <v-text-field
                      v-model="toSolicitanteEmail"
                      :rules="emailRules"
                      label="Solicitante"
                      :hint="toSolicitante"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 px-1>
                    <v-text-field
                      v-model="toPacienteEmail"
                      :rules="emailRules"
                      label="Paciente"
                      :hint="toPaciente"
                      persistent-hint
                      :readonly="!activeToPaciente"
                      :class="activeToPaciente ? '' : 'line-through'"
                      :prepend-icon="iconPaciente"
                      @click:prepend="activeToPaciente = !activeToPaciente"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-combobox
                      class="elevation-0 mt-border-bottom"
                      v-model="ccSelected"
                      :items="cc"
                      label="Con Copia (opcional)"
                      multiple
                      chips
                      tags
                    >
                      <!-- clearable -->
                      <template v-slot:selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          :selected="data.selected"
                          :disabled="data.disabled"
                          class="v-chip--select-multi"
                          :color="isEmail(data.item) ? 'green' : 'red'"
                          @input="removeChip(data.index, data.parent)"
                          text-color="white"
                          close
                        >
                          <strong>{{ data.item }}</strong>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>

                  <v-divider dark class="my-3"></v-divider>

                  <!-- 
                <v-textarea
                  box
                  v-model="commentReopen"
                  label="Motivo de corrección"
                  background-color="secondary"
                  color="primary"
                  :loading="loadingComment"
                  :readonly="loadingComment"
                  autofocus
                  counter
                ></v-textarea> 
                  -->
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray darken-1" flat @click="dialogEmail = false"
                >Cerrar</v-btn
              >
              <v-btn color="primary darken-1" @click="sendEmail"
                >Enviar Email</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <vue-context ref="menuExam">
          <template slot-scope="child" v-if="child.data">
            <li>
              <a href="#" @click.prevent="deleteExam(child.data.item)"
                >Eliminar</a
              >
            </li>
          </template>
        </vue-context>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
          {{ snackText }}
          <v-btn flat @click="snack = false">Cerrar</v-btn>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import { bus } from "./../main";
import { VueContext } from "vue-context";

// import Templates from './Templates.vue';
var moment = require("moment");
const confBase = {
  timeout: 60000,
  withCredentials: true,
  responseType: "json",
  headers: {
    Accept: "application/json",
    "Content-Type": "x-www-form-urlencoded",
  },
  params: {},
};
export default {
  components: {
    VueContext,
    // Templates
  },
  mounted() {
    this.logged_user = JSON.parse(localStorage.getItem("logged_user"));

    if (!this.logged_user) {
      bus.$emit("userStatus", {
        isLogged: false,
        message: "Sesión de usuario finalizada",
      });
    }

    /**
     * ROLES
     * 1: Administrador
     * 2: Tecnólogo
     * 3: Dentista
     * 4: Solicitante
     * 5: Paciente
     * 6: Personal
     */

    if (
      this.logged_user.id_perfil === "4" ||
      this.logged_user.id_perfil === "5"
    ) {
      this.$router.push({ name: "Find" });
      return;
    }
    this.initialize();
  },

  data: (vm) => ({
    pagename: "EXÁMENES",
    logged_user: null,
    snack: false,
    snackColor: "",
    snackText: "",
    dialogComments: false,
    loadingComment: false,
    comments: [],
    newComment: "",
    dialogImages: false,
    images: [],
    imagesSRC: [],
    viewerOptions: {
      toolbar: true,
      url: "data-source",
    },
    viewers: [],
    selIndex: 0,
    mods: [],
    filters: {
      search: "",
      mods: "",
      startDate: null,
      endDate: null,
      doctors: "",
      states: "",
      institutions: "",
    },
    serveStates: "1, 2, 3, 5, 6",
    serveInterval: 3,
    serveValidates: false,
    startDate: null,
    endDate: new Date().toISOString().substr(0, 10),
    menuStartDate: false,
    menuEndDate: false,
    search: "",
    mod: null,
    doctor: [],
    state: null,
    institution: null,
    pagination: {
      sortBy: "fecha_hora_examen",
      descending: true,
      rowsPerPage: 10,
    },
    doctors: [],
    doctorStr: null,
    states: [],
    institutions: [],
    headers: [
      {
        text: "#C",
        value: "condicion",
        sortable: false,
        align: "center",
        class: "px-2",
      },
      {
        text: "I",
        value: "numero_archivos",
        sortable: false,
        align: "center",
        class: "px-2",
      },
      {
        text: "Fecha Examen",
        value: "fecha_hora_examen",
        align: "center",
        class: "px-2",
      },
      { text: "Tiempo", value: "tiempo", sortable: false, class: "px-2" },
      {
        text: "IDPaciente",
        value: "IDPaciente",
        sortable: false,
        class: "px-2",
      },
      { text: "Nombre", value: "nombre", sortable: false, class: "px-2" },
      { text: "Edad", value: "edad", sortable: false, class: "px-2" },
      // { text: 'Correo paciente', value: 'correo_paciente', sortable: false, class:'px-2' },
      { text: "Mod", value: "modalidad", sortable: false, class: "px-2" },
      {
        text: "Radiólogo",
        value: "medico_informante",
        sortable: false,
        class: "px-2",
      },
      { text: "Inst.", value: "institucion", sortable: false, class: "px-2" },
      { text: "Estado", value: "id_estado", sortable: false, class: "px-2" },
      { text: "Acciones", sortable: false, align: "left", class: "px-2" },
    ],
    loadingExams: false,
    exams: [],
    examSelected: null,
    desserts: [],
    totalDesserts: 0,
    rowsPerPageItems: [10, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    defaultItem: {
      name: "",
      calories: 0,
      fat: 0,
      carbs: 0,
      protein: 0,
    },
    emailRules: [
      //v => !!v || "Correo es requerido",
      (v) => /.+@.+/.test(v) || !v || "El correo debe ser válido",
    ],
    dialogInformar: false,
    informarPrestaciones: [],
    prestacionesSelected: [],
    informes: [],
    dialogVerInforme: false,
    dialogReabrirInforme: false,
    informesValidados: [],
    reportSelected: null,
    comentariosReabrir: [],
    commentReopen: null,
    dialogEmail: false,
    toSolicitante: "",
    toSolicitanteEmail: "",
    toPaciente: "",
    toPacienteEmail: "",
    activeToPaciente: true,
    cc: [],
    textCC: "",
    ccSelected: null,
    disabledoctors: false,
    perfil_medicos: "2,3",
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    imageIndicator() {
      return this.selIndex + 1 + "/" + this.imagesSRC.length;
    },
    iconPaciente() {
      return this.activeToPaciente ? "check_box" : "check_box_outline_blank";
    },
    startDateFormattedMomment() {
      return this.startDate ? moment(this.startDate).format("DD/MM/YYYY") : "";
    },
    endDateFormattedMomment() {
      return this.endDate ? moment(this.endDate).format("DD/MM/YYYY") : "";
    },
    typeViewer() {
      return this.logged_user.id_perfil == 6 ? "newimagenes" : "imagenes";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    pagination: {
      handler() {
        if (!this.loadingExams) {
          // console.log('pagination handle', JSON.parse(JSON.stringify(this.pagination)))
          localStorage.paginationPage = this.pagination.page;
          localStorage.paginationRowsPerPage = this.pagination.rowsPerPage;
          this.getData(false);
        }
        // this.getDataFromApi()
        //   .then(data => { console.log('getDataFromApi', data)
        //     this.desserts = data.items
        //     this.totalDesserts = data.total
        //   })
      },
      deep: true,
    },
    // search: {

    // },
    // mod: {

    // },
    // startDate: {

    // },
    // endDate: {

    // },
    // doctor: {

    // },
    // state: {

    // },
    // institution: {

    // }
  },

  methods: {
    initialize() {
      this.loadingExams = true;
      this.desserts = [];
      this.totalDesserts = 0;

      Promise.all([
        // this.getExamenes(),
        this.getUsuariosPerfiles(),
        this.getEstados(),
        this.getInstituciones(),
        this.getModalidades(),
      ])
        .then((response) => {
          if (localStorage.filterSearch) {
            this.search = localStorage.filterSearch;
            this.filterSearch(this.search);
          }
          if (localStorage.filterMods) {
            this.mod = JSON.parse(localStorage.filterMods);
            this.filterMods(this.mod);
          }
          if (localStorage.filterStartDate) {
            this.startDate = localStorage.filterStartDate;
            this.filterStartDate(this.startDate);
          }
          if (localStorage.filterEndDate) {
            this.endDate = localStorage.filterEndDate;
            this.filterEndDate(this.endDate);
          }
          if (localStorage.filterDoctors) {
            this.doctor = JSON.parse(localStorage.filterDoctors);
            this.filterDoctors(this.doctor);
          }
          if (localStorage.filterStates) {
            this.state = JSON.parse(localStorage.filterStates);
            this.filterStates(this.state);
          }
          if (localStorage.filterInstitutions) {
            this.institution = JSON.parse(localStorage.filterInstitutions);
            this.filterInstitutions(this.institution);
          }

          if (localStorage.paginationPage) {
            this.pagination.page = parseInt(localStorage.paginationPage);
            // console.log('pagination page', JSON.parse(JSON.stringify(this.pagination)))
          }

          if (localStorage.paginationRowsPerPage) {
            this.pagination.rowsPerPage = parseInt(
              localStorage.paginationRowsPerPage
            );
            // console.log('pagination rowspp', JSON.parse(JSON.stringify(this.pagination)))
          }

          this.snackColor = "success";
          this.snackText = "Filtros cargados exitosamente.";
          this.snack = true;
          this.getData();
        })
        .catch((reason) => {
          this.loadingExams = false;
          console.log("error", reason);
          this.snackColor = "error";
          this.snackText = reason;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .finally(() => {
          //nada
          // this.loadingExams = false;
        });
    },

    getData(clean = false) {
      // console.log('doctor', JSON.parse(JSON.stringify(this.doctor)))
      this.loadingExams = true;
      if (clean) {
        this.desserts = [];
        this.totalDesserts = 0;
      }

      this.filterSearch(this.search);
      this.filterMods(this.mod);
      this.filterStartDate(this.startDate);
      this.filterEndDate(this.endDate);
      this.filterDoctors(this.doctor);
      this.filterStates(this.state);
      this.filterInstitutions(this.institution);
      this.getDataLengthFromApi()
        .then((total) => {
          const { sortBy, descending, page, rowsPerPage } = this.pagination;
          this.totalDesserts = total;
          //console.log('length api data', JSON.parse(JSON.stringify(this.pagination)), total, (total/rowsPerPage))
          if (Math.ceil(total / rowsPerPage) < page) {
            this.pagination.page = 1;
          }
          this.snack = false;
          this.getDataFromApi()
            .then((items) => {
              this.desserts = items;
              this.snackColor = "success";
              this.snackText = "Exámenes cargados exitosamente.";
              this.snack = true;
            })
            .catch((reason) => {
              console.log("error", reason);
              this.snackColor = "error";
              this.snackText = reason;
              this.snack = true;
              setTimeout(() => {
                bus.$emit("userStatus", {
                  isLogged: false,
                  message: "Sesión de usuario finalizada",
                });
              }, 1000);
            })
            .finally(() => {
              this.loadingExams = false;
            });
        })
        .catch((reason) => {
          this.loadingExams = false;
          console.log("error", reason);
          this.snackColor = "error";
          this.snackText = reason;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .finally(() => {
          //nada
        });
      /*
        Promise.all([this.getDataFromApi(), this.getDataLengthFromApi()])
        .then(response => {
          //console.log('response', response)
          const [items, total] = response;
          // console.log(items, total)
          this.desserts = items;
          this.totalDesserts = total;
          this.snackColor = "success";
          this.snackText = "Exámenes cargados exitosamente.";
          this.snack = true;
        })
        .catch(reason => {
          console.log("error", reason);
          this.snackColor = "error";
          this.snackText = reason;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada"
            });
          }, 1000);
        })
        .finally(() => {
          this.loadingExams = false;
        });
      */
    },

    getDataLengthFromApi() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "cantidadRegistros",
          api_token: this.logged_user.api_token,
          id_institucion: this.institution
            ? this.institution.map((el) => el.id_institucion).join(",")
            : null,
          id_usuario: this.doctor
            ? this.doctor.map((el) => el.id_usuario).join(",")
            : null,
          id_estado: this.state
            ? this.state.map((el) => el.id_estado).join(",")
            : null,
          id_modalidad: this.mod
            ? this.mod.map((el) => el.id_modalidad).join(",")
            : null,
          fdesde: this.startDate,
          fhasta: this.endDate,
          fPaciente: this.search,
        };

        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              // console.log('getDataLengthFromApi', JSON.parse(JSON.stringify(result.data.callback)))
              const total = result.data.callback.total_registros;
              resolve(total);
            }
          });
      });
    },

    getDataFromApi() {
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;

        confBase.params = {
          accion: "examenes",
          api_token: this.logged_user.api_token,
          id_institucion: this.institution
            ? this.institution.map((el) => el.id_institucion).join(",")
            : null,
          id_usuario: this.doctor
            ? this.doctor.map((el) => el.id_usuario).join(",")
            : null,
          id_estado: this.state
            ? this.state.map((el) => el.id_estado).join(",")
            : null,
          id_modalidad: this.mod
            ? this.mod.map((el) => el.id_modalidad).join(",")
            : null,
          fdesde: this.startDate,
          fhasta: this.endDate,
          fPaciente: this.search,
          pagina: page,
          catidadRegistros: rowsPerPage,
        };

        console.log("confBase", JSON.parse(JSON.stringify(confBase)));
        console.log("doctor", JSON.parse(JSON.stringify(this.doctor)));

        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              //console.log('ajax', JSON.parse(JSON.stringify(result.data.callback)))
              let items = result.data.callback.map((examen) => {
                examen.numero_archivos = examen.archivos.filter(
                  (el) => el.tipo == "dcm"
                ).length;
                examen.haveDcm = examen.numero_archivos > 0;
                examen.haveOtrodcm =
                  examen.archivos.filter((el) => el.tipo == "otrodcm").length >
                  0;
                examen.haveMod =
                  examen.archivos.filter((el) => el.tipo == "mod").length > 0;
                examen.haveStl =
                  examen.archivos.filter((el) => el.tipo == "stl").length > 0;
                examen.alive = moment(examen.fecha_hora_examen)
                  .locale("es")
                  .fromNow();
                examen.informes.forEach((informe) => {
                  informe.prestaciones = informe.prestaciones_informe.map(
                    (prestacionid) => {
                      return examen.prestaciones_todas.find(
                        (el) => el.id_prestacion == prestacionid
                      );
                    }
                  );
                  if (informe.prestaciones.length > 0) {
                    informe.nombre = informe.prestaciones
                      .map(function(elem) {
                        return elem
                          ? elem.nombre_prestacion
                          : "Error en asignación de prestación";
                      })
                      .join(" y ");
                  }
                });
                examen.comentarios.forEach((comentario) => {
                  comentario.alive = moment(comentario.fecha_registro)
                    .locale("es")
                    .fromNow();
                });
                return examen;
              });

              //console.log('items', JSON.parse(JSON.stringify(items)))

              // const total = 60 //items.length

              if (this.pagination.sortBy) {
                items = items.sort((a, b) => {
                  const sortA = a[sortBy];
                  const sortB = b[sortBy];

                  if (descending) {
                    if (sortA < sortB) return 1;
                    if (sortA > sortB) return -1;
                    return 0;
                  } else {
                    if (sortA < sortB) return -1;
                    if (sortA > sortB) return 1;
                    return 0;
                  }
                });
              }

              if (rowsPerPage > 0) {
                //items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
              }

              resolve(items);
            } else {
              reject("No data result (getDataFromApi)");
            }
          })
          .catch((error) => {
            reject("Error ajax (getDataFromApi), " + error);
          });
      });
    },

    getExamenes() {
      // console.log("getExamenes");
      // $idInstitucion=$_REQUEST['id_institucion'],
      // $idUsuario=$_REQUEST['id_usuario'],
      // $idEstado=$_REQUEST['id_estado'],
      // $idModalidad=$_REQUEST['id_modalidad'],
      // $fechaDesde=$_REQUEST['fdesde'],
      // $fechaHasta=$_REQUEST['fhasta'],
      // $filtroPaciente=$_REQUEST['fPaciente'],
      // $numPagina=$_REQUEST['pagina'],
      // $registrosPagina=$_REQUEST['catidadRegistros']
      this.filterSearch(this.search);
      this.filterMods(this.mod);
      this.filterStartDate(this.startDate);
      this.filterEndDate(this.endDate);
      this.filterDoctors(this.doctor);
      this.filterStates(this.state);
      this.filterInstitutions(this.institution);
      console.log("getExamenes", this.doctor);

      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "examenes",
          api_token: this.logged_user.api_token,
          id_institucion: this.institution,
          id_usuario: this.doctor,
          id_estado: this.state,
          id_modalidad: this.mod
            ? this.mod.map((el) => el.id_modalidad).join(",")
            : null,
          fdesde: this.startDate,
          fhasta: this.endDate,
          fPaciente: this.search,
          pagina: 1,
          catidadRegistros: 10,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            console.log("RESULT", result);
            if (result.data.response) {
              this.desserts = result.data.callback.map((examen) => {
                examen.numero_archivos = examen.archivos.filter(
                  (el) => el.tipo == "dcm"
                ).length;
                examen.haveDcm = examen.numero_archivos > 0;
                examen.haveOtrodcm =
                  examen.archivos.filter((el) => el.tipo == "otrodcm").length >
                  0;
                examen.haveMod =
                  examen.archivos.filter((el) => el.tipo == "mod").length > 0;
                examen.haveStl =
                  examen.archivos.filter((el) => el.tipo == "stl").length > 0;
                examen.alive = moment(examen.fecha_hora_examen)
                  .locale("es")
                  .fromNow();
                examen.informes.forEach((informe) => {
                  informe.prestaciones = informe.prestaciones_informe.map(
                    (prestacionid) => {
                      return examen.prestaciones.find(
                        (el) => el.id_prestacion == prestacionid
                      );
                    }
                  );
                  if (informe.prestaciones.length > 0) {
                    informe.nombre = informe.prestaciones
                      .map(function(elem) {
                        return elem
                          ? elem.nombre_prestacion
                          : "Error en asignación de prestación";
                      })
                      .join(" y ");
                  }
                });
                examen.comentarios.forEach((comentario) => {
                  comentario.alive = moment(comentario.fecha_registro)
                    .locale("es")
                    .fromNow();
                });
                // examen.archivosURL = window.base_path + window.filesDCM
                return examen;
              });
              //console.log('Examenes',JSON.parse(JSON.stringify(this.desserts)))
              resolve("Examenes cargados");
            } else {
              reject("No data result (getExamenes)");
            }
          })
          .catch((error) => {
            reject("Error ajax, " + error);
          });
      });
    },

    getModalidades() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "modalidades",
          opcion: "listarModalidades",
          estado: 1,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              this.mods = result.data.callback;
              resolve();
            } else {
              reject("No data result (getModalidades)");
            }
          })
          .catch((error) => {
            reject("Error ajax (getExamenes), " + error);
          });
      });
    },

    getUsuariosPerfiles() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "usuariosPerfiles",
          api_token: this.logged_user.api_token,
          id_perfil: this.perfil_medicos, // médicos
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              // this.logged_user.id_usuario = this.logged_user.id;
              // console.log('getUsuariosPerfiles', JSON.parse(JSON.stringify(this.logged_user)))
              if (this.logged_user.id_perfil == 3) {
                this.logged_user.id_usuario = this.logged_user.id;
                this.doctors = [this.logged_user];
                this.doctor = this.doctors;
                this.filterDoctors(this.doctor);
                this.disabledoctors = true;
                console.log(
                  "getUsuariosPerfiles doctor",
                  JSON.parse(JSON.stringify(this.doctor)),
                  JSON.parse(JSON.stringify(this.doctors))
                );
              } else {
                this.doctors = result.data.callback;
                // .map(doctor => {
                //   doctor.nombre_completo =
                //     doctor.nombres + " " + doctor.apellidos;
                //   return doctor;
                // });
              }
              resolve("Usuarios cargados");
            } else {
              reject("No data result (getUsuariosPerfiles)");
            }
          })
          .catch((error) => {
            reject("Error ajax (getUsuariosPerfiles), " + error);
          });
      });
    },

    getEstados() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "estados",
          api_token: this.logged_user.api_token,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              //console.log(JSON.parse(JSON.stringify(result.data.callback)))
              this.states = result.data.callback;
              resolve("Estados cargados");
            } else {
              reject("No data result (getEstados)");
            }
          })
          .catch((error) => {
            reject("Error ajax (getEstados), " + error);
          });
      });
    },

    getInstituciones() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "instituciones",
          estado: 1,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              //console.log(JSON.parse(JSON.stringify(result.data.callback)))
              this.institutions = result.data.callback;
              resolve("Instituciones cargadas");
            } else {
              // console.log('no data')
              reject("No data result (getInstituciones)");
            }
          })
          .catch((error) => {
            reject("Error ajax (getInstituciones), " + error);
          });
      });
    },

    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
      this.$router.push({
        name: "ExamEdit",
        params: { id_examen: item.id },
      });
    },

    selectPrestations(item) {
      this.examSelected = item;
      this.informarPrestaciones = item.prestaciones.filter(
        (el) => el.informado === 0
      );
      this.informes = item.informes.filter((el) => el.validado_informe == 0);
      if (
        this.informarPrestaciones.length === 1 &&
        this.informes.length === 0
      ) {
        //console.log('informarPrestaciones', this.informarPrestaciones.pop().id_prestacion)
        this.prestacionesSelected.push(
          this.informarPrestaciones.pop().id_prestacion
        );
        this.reportItem({ prestaciones: this.prestacionesSelected });
      }
      this.dialogInformar = true;
    },

    reportItem(queryParams) {
      this.$router.push({
        name: "ExamReport",
        params: { id_examen: this.examSelected.id },
        query: queryParams,
      });
    },

    selectReportView(item) {
      this.examSelected = item;
      this.informesValidados = item.informes.filter(
        (el) => el.validado_informe == 1
      );
      if (this.informesValidados.length === 1) {
        this.viewReport(this.informesValidados[0]);
      }
      this.dialogVerInforme = true;
    },

    viewReport(report) {
      //console.log('ver', report.id_informe)
      this.loadingExams = true;
      // const confFile = {
      //   timeout: 10000,
      //   withCredentials: true,
      //   responseType: 'blob',
      //   params: {
      //     accion: 'informePDF',
      //     id_informe: report.id_informe,
      //     api_token: this.logged_user.api_token
      //   }
      // }

      confBase.params = {
        accion: "informePDF",
        id_informe: report.id_informe,
        api_token: this.logged_user.api_token,
      };

      axios
        .create(confBase)
        .get(window.base_path + window.ws)
        .then((result) => {
          // console.log('result', JSON.parse(JSON.stringify(result)))
          if (result.data.response) {
            window.open(result.data.ruta, "_blank");
            // let base64data
            // var blob = new Blob([result.data])
            // const url = window.URL.createObjectURL(blob);
            // window.open(url, '_blank')

            // var reader = new FileReader()
            // reader.readAsDataURL(blob);
            // reader.onloadend = function() {
            //   base64data = reader.result
            //   console.log(base64data)

            //   const link = document.createElement('a')
            //   link.href = base64data
            //   link.setAttribute('download', 'informe_'+report.nombre+'.pdf'); //or any other extension
            //   link.setAttribute('target', '_blank')
            //   document.body.appendChild(link)
            //   //console.log('link', link)
            //   link.click()
            // }
          } else {
            // console.log('no link')
            this.snackColor = "error";
            this.snackText = "El informe del exámen no fué encontrado.";
            this.snack = true;
          }
        })
        .catch((error) => {
          // console.log("error", JSON.parse(JSON.stringify(result)));
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        })
        .then(() => {
          this.loadingExams = false;
          this.snack = false;
        });
    },

    selectReportReopen(item) {
      this.reportSelected = null;
      this.examSelected = item;
      this.comentariosReabrir = [];
      this.commentReopen = null;
      this.informesValidados = item.informes.filter(
        (el) => el.validado_informe == 1
      );
      if (this.informesValidados.length > 0) {
        this.reportSelected = this.informesValidados[0];
        //let comentarios = this.getComentariosReabrir()
      }
      // console.log('validados', JSON.parse(JSON.stringify(this.informesValidados)))

      this.dialogReabrirInforme = true;
    },

    getComentariosReabrir() {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "reabrir",
          opcion: "listarReaperturas",
          id_informe: this.reportSelected.id_informe,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              // console.log('comentariosReabrir', JSON.parse(JSON.stringify(result.data.callback)))
              this.comentariosReabrir = result.data.callback.map((el) => {
                el.alive = moment(el.fecha_registro)
                  .locale("es")
                  .fromNow();
                return el;
              });
              resolve("Comentarios cargados");
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax, " + error);
          });
      });
    },

    reOpenReport() {
      // console.log('reOpenReport', this.commentReopen, JSON.parse(JSON.stringify(this.reportSelected)))
      var contentData = {
        accion: "reabrir",
        opcion: "corregir",
        id_informe: this.reportSelected.id_informe,
        id_examen: this.examSelected.id,
        id_usuario: this.logged_user.id,
        comentario: this.commentReopen,
        api_token: this.logged_user.api_token,
      };

      axios({
        method: "post",
        withCredentials: true,
        url: window.base_path + window.ws,
        data: contentData,
      })
        .then((result) => {
          // console.log('result reopen', JSON.parse(JSON.stringify(result)))
          if (result.data.response) {
            this.snackColor = "success";
            this.snackText = result.data.mensaje;
            this.prestacionesSelected = this.reportSelected.prestaciones.map(
              (el) => el.id_prestacion
            );
            //console.log('prestacionesSelected',this.prestacionesSelected)
            this.reportItem({ id_informe: this.reportSelected.id_informe });
          } else {
            this.snackColor = "error";
            this.snackText = result.data.message;
          }
          this.snack = true;
        })
        .catch((error) => {
          // console.log('error',error)
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .then(() => {
          this.loadingComment = false;
        });
    },

    selectReportEmail(item) {
      this.reportSelected = null;
      this.examSelected = item;
      this.informesValidados = item.informes.filter(
        (el) => el.validado_informe == 1
      );

      /* this.getSolicitante(this.examSelected.id_solicitante).then(solicitante => {
            console.log('ok', solicitante)
          }).catch(error => {
            console.log('error', error)
          }) */
      this.toSolicitante = this.examSelected.medico_solicitante;
      this.toSolicitanteEmail = this.examSelected.correo_solicitante;

      this.toPaciente = this.examSelected.nombre;
      this.toPacienteEmail = this.examSelected.correo_paciente;

      //console.log('this.informesValidados', this.informesValidados)
      if (this.informesValidados.length > 0) {
        //this.reportSelected = this.informesValidados[0]
      } else {
        //nada
      }

      // console.log(JSON.parse(JSON.stringify(this.examSelected)))

      this.dialogEmail = true;
    },

    isEmail(v) {
      if (v.length === 0) {
        return false;
      }
      if (!/.+@.+/.test(v)) {
        return false;
      }
      return true;
    },

    getSolicitante(id_solicitante) {
      return new Promise((resolve, reject) => {
        confBase.params = {
          accion: "solicitantes",
          opcion: "listarSolicitante",
          id_solicitante: id_solicitante,
          api_token: this.logged_user.api_token,
        };
        axios
          .create(confBase)
          .get(window.base_path + window.ws)
          .then((result) => {
            if (result.data.response) {
              //console.log(JSON.parse(JSON.stringify(result.data.callback)))
              resolve(result.data.callback);
            } else {
              reject("No data result");
            }
          })
          .catch((error) => {
            reject("Error ajax, " + error);
          });
      });
    },

    removeChip(index, parent) {
      // console.log('remove', index, parent)
      this.ccSelected.splice(index, 1);
    },

    updateCC(val) {
      let last = this.cc.pop();

      // console.log('update', last, this.cc)
      /* this.$nextTick(() => {
          this.cc.push(...this.textCC.split(","));
          this.$nextTick(() => {
            this.textCC = "";
          });
        }); */
    },

    sendEmail() {
      let conCopia;

      this.loadingExams = true;

      if (this.ccSelected) {
        conCopia = this.ccSelected.filter((el) => this.isEmail(el)).join(", ");
      }
      // console.log('send email', this.reportSelected, this.toSolicitanteEmail, this.toPacienteEmail, conCopia)
      var contentData = {
        accion: this.reportSelected ? "enviarCorreo" : "enviarCorreoSinInforme",
        id_informe: this.reportSelected ? this.reportSelected.id_informe : null,
        id_examen: this.examSelected.id,
        correo_solicitante: this.toSolicitanteEmail,
        correo_paciente: this.toPacienteEmail,
        otros_correos: conCopia,
        api_token: this.logged_user.api_token,
      };

      axios({
        method: "post",
        withCredentials: true,
        url: window.base_path + window.ws,
        data: contentData,
      })
        .then((result) => {
          //console.log('result enviarCorreo', JSON.parse(JSON.stringify(result)))
          if (result.data.response) {
            this.snackColor = "success";
            this.snackText = "Correo enviado exitósamente!"; //result.data.mensaje
            this.dialogEmail = false;
          } else {
            this.snackColor = "error";
            this.snackText = result.data.mensaje;
          }
          this.snack = true;
        })
        .catch((error) => {
          //console.log('error',error)
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .then(() => {
          this.loadingExams = false;
        });
    },

    commentItem(val, index) {
      this.examSelected = val;
      this.examSelected.index = index;
      this.comments = val.comentarios;
      this.dialogComments = true;
    },

    comentarExamen() {
      // console.log('comentando')

      this.loadingComment = true;

      var contentData = {
        accion: "comentarios",
        opcion: "comentarExamen",
        id_examen: this.examSelected.id,
        comentario: this.newComment,
        api_token: this.logged_user.api_token,
      };

      axios({
        method: "post",
        withCredentials: true,
        url: window.base_path + window.ws,
        data: contentData,
      })
        .then((result) => {
          // console.log(result)
          if (result.data.response) {
            this.snackColor = "success";
            this.snackText = result.data.mensaje;
            const now = moment().format();
            let addComment = {
              comentario: this.newComment,
              correo_autor: this.logged_user.email,
              fecha_registro: now,
              alive: moment(now)
                .locale("es")
                .fromNow(),
              id_autor: this.logged_user.id,
              id_comentario: "0",
              nombre_autor:
                this.logged_user.nombres + " " + this.logged_user.apellidos,
            };
            // console.log('examSelected', JSON.parse(JSON.stringify(this.examSelected)))
            setTimeout(() => {
              //this.exams[this.examSelected.index].comentarios.push(addComment)
              this.examSelected.comentarios.unshift(addComment);
              this.newComment = "";
              this.loadingComment = false;
            }, 1000);
          } else {
            this.snackColor = "error";
            this.snackText = result.data.message;
          }
          this.snack = true;
        })
        .catch((error) => {
          // console.log('error',error)
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          setTimeout(() => {
            bus.$emit("userStatus", {
              isLogged: false,
              message: "Sesión de usuario finalizada",
            });
          }, 1000);
        })
        .then(() => {
          this.loadingComment = false;
        });
    },

    // viewDicom (item) {
    // CR.1.2.392.200036.9125.9.0.253518703.253362207.688224813
    // window.open('http://rd.nubedesign.cl/radiodent/DicomWebViewer/app/?image='+item.archivos[0].dcm.ArchivoDCM, '_blank')
    // },

    inited(viewer) {
      this.$viewer = viewer;
    },

    getImageURL(image) {
      return window.base_path + window.filesDCM + image;
    },

    async viewImage(item, type) {
      this.images = item.archivos.filter((file) => file.tipo == type);
      this.images.forEach((image) => {
        switch (type) {
          case "dcm":
            image.src = window.base_path + window.filesDCM + image.ArchivoJPG;
            break;
          case "orden":
            image.src = window.base_path + window.filesORDEN + image.nomArchivo;
            break;
        }
        // console.log("img", type, image.src);
      });
      this.loadingExams = true;
      setTimeout(() => {
        this.$refs["viewer"].$viewer.show();
        this.loadingExams = false;
      }, 1000);
    },

    downloadZip(item, tipo) {
      // console.log('descargar', tipo, JSON.parse(JSON.stringify(item)))
      // this.loadingExams = true;
      bus.$emit("tradeDCM", {
        status: "start",
        text:
          "Descargando archivo " +
          tipo.toUpperCase() +
          " para paciente: " +
          item.IDPaciente,
        color: "loaddcm",
      });

      let files = item.archivos.filter((file) => file.tipo == tipo);

      // if (tipo === "otrodcm") {
      //   window.open(files[0].url, "_blank");
      //   this.loadingExams = false;
      //   return;
      // }
      // console.log('Files', tipo, JSON.parse(JSON.stringify(files)))
      var numFiles = files.length;
      // console.log('numFiles', numFiles)
      const confFile = {
        timeout: 0,
        withCredentials: true,
        responseType: "blob",
        params: {
          accion: "comprimirArchivos",
          id_examen: item.id,
          tipo_archivo: tipo,
          api_token: this.logged_user.api_token,
        },
      };

      axios
        .create(confFile)
        .get(window.base_path + window.ws)
        .then((result) => {
          // console.log('result download', JSON.parse(JSON.stringify(result)), result.data.toString.length, typeof result.data.toString)
          if (result.data) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement("a");
            // let ext = numFiles === 1 && (tipo === 'dcm' || tipo === 'mod') ? '.jpg' : '.zip'
            let ext;
            if (numFiles > 1) {
              ext = ".zip";
            } else {
              switch (tipo) {
                case "stl":
                  ext = ".stl";
                  break;
                case "otrodcm":
                  ext = ".dcm";
                  break;
                default:
                  ext = ".jpg";
                  break;
              }
            }
            bus.$emit("tradeDCM", {
              status: "success",
              text:
                "Archivo " +
                tipo.toUpperCase() +
                " listo para descargar de paciente: " +
                item.IDPaciente,
              color: "green",
            });

            setTimeout(() => {
              link.href = url;
              link.setAttribute(
                "download",
                "paciente_" + item.IDPaciente + ext
              ); //or any other extension
              document.body.appendChild(link);
              // console.log('link')
              link.click();
            }, 1000);
          } else {
            // console.log('no link')
            bus.$emit("tradeDCM", {
              status: "error",
              text:
                "El archivo " +
                tipo.toUpperCase() +
                " no se encontró para paciente: " +
                item.IDPaciente,
              color: "error",
            });
            this.snackColor = "error";
            this.snackText = "las imagenes de exámen no fueron encontradas.";
            this.snack = true;
          }
        })
        .catch((error) => {
          //console.log('error', JSON.parse(JSON.stringify(result)))
          bus.$emit("tradeDCM", {
            status: "error",
            text:
              "El archivo " +
              tipo.toUpperCase() +
              " no se encontró para paciente: " +
              item.IDPaciente,
            color: "error",
          });
          this.snackColor = "error";
          this.snackText = error.response;
          this.snack = true;
          // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
        })
        .then(() => {
          // this.loadingExams = false;
          this.snack = false;
        });
    },

    deleteExam(item) {
      const index = this.desserts.indexOf(item);
      // console.log("item", index, JSON.parse(JSON.stringify(item)));
      if (
        confirm(
          "Está usted seguro/a que desea eliminar este examen? IDPaciente: " +
            item.IDPaciente +
            " / Nombre: " +
            item.nombre
        )
      ) {
        var contentData = {
          accion: "examen",
          opcion: "borrar",
          id_examen: item.id,
          api_token: this.logged_user.api_token,
        };
        //console.log('formData', JSON.parse(JSON.stringify(formData)))

        axios({
          method: "post",
          withCredentials: true,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          url: window.base_path + window.ws,
          data: contentData,
        })
          .then((result) => {
            //console.log('result modificar examen', contentData, JSON.parse(JSON.stringify(result)))
            if (result.data.response) {
              // resolve('Exámen eliminado correctamente')
              this.snackColor = "success";
            } else {
              // reject(result.data.message)
              this.snackColor = "error";
            }
            // this.loading = false
            this.getExamenes();
            this.snackText = result.data.mensaje;
            this.snack = true;
          })
          .catch((error) => {
            //console.log('error modificar examen',error)
            // reject(error.response)
            this.snackColor = "error";
            this.snackText = error.response;
            this.snack = true;
            // setTimeout(()=>{ bus.$emit("userStatus", { isLogged: false, message: "Sesión de usuario finalizada" }); }, 1000)
          });
      } //&& this.desserts.splice(index, 1)
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    formatDate(date) {
      if (!date) return "-";

      return moment(date).format("DD/MM/YYYY hh:mm:ss");
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    dateFromServer(fulldate) {
      if (!fulldate) return null;
      const [date, time] = fulldate.split(" ");
      const [day, month, year] = date.split("/");
      const [hrs, min, sec] = time.split(":");
      return new Date(year, month - 1, day, hrs, min, sec);
    },

    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      var that = this;

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord === null || searchWord.trim() === "") return items;

        return items.filter((item) => {
          return (
            item.nombre.toLowerCase().includes(searchWord.toLowerCase()) ||
            item.IDPaciente.toLowerCase().includes(searchWord.toLowerCase())
          );
        }, searchWord);
      });

      cf.registerFilter("mods", function(mods, items) {
        // if (mods.trim() === '') return items;
        if (mods.length === 0) return items;

        return items.filter((item) => {
          //return mods.includes(item.modalidad);
          return mods.some((el) => el.sigla == item.modalidad);
        }, mods);
      });

      cf.registerFilter("startDate", function(startDate, items) {
        if (startDate === null) return items;

        return items.filter((item) => {
          // console.log('A ',item.fecha_hora_examen)
          // console.log('B ', that.parseDate(item.fecha_hora_examen))
          // console.log('C ', that.dateFromServer(item.fecha_hora_examen).getTime())
          // console.log('eval',new Date(that.dateFromServer(item.fecha_hora_examen).getTime()), new Date(startDate))
          // return that.dateFromServer(item.fecha_hora_examen).getTime() >= startDate;
          return moment(item.fecha_hora_examen) >= startDate;
        }, startDate);
      });

      cf.registerFilter("endDate", function(endDate, items) {
        if (endDate === null) return items;

        // Compare each item endDate and just return the matching ones.
        return items.filter((item) => {
          // return that.dateFromServer(item.fecha_hora_examen).getTime() <= (endDate + (24*60*60*1000))
          return moment(item.fecha_hora_examen) <= endDate; //+ (24*60*60*1000)
        }, endDate);
      });

      cf.registerFilter("doctors", function(doctors, items) {
        //console.log('doctors', doctors)
        if (doctors.length === 0) return items;

        return items.filter((item) => {
          return doctors.some((doctor) => {
            return doctor.nombre_completo == item.medico_informante;
          });
        }, doctors);
      });

      cf.registerFilter("states", function(states, items) {
        if (states.length === 0) return items;

        return items.filter((item) => {
          return states.some((state) => {
            return state.id_estado == item.id_estado;
          });
        }, states);
      });

      cf.registerFilter("institutions", function(institutions, items) {
        if (institutions.length === 0) return items;

        return items.filter((item) => {
          return institutions.some((institution) => {
            return institution.id_institucion == item.id_institucion;
          });
        }, institutions);
      });

      return cf.runFilters();
    },

    filterSearch(val) {
      localStorage.filterSearch = val ? val : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {search: val});
    },

    filterMods(val) {
      //console.log('filterMods', JSON.parse(JSON.stringify(val)), typeof val, val.length)
      localStorage.filterMods =
        val && val.length > 0 ? JSON.stringify(val) : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {mods: val});
    },

    filterStartDate(val) {
      if (val === null) this.startDate = null;
      this.$refs.menuStartDate.save(val);
      let start = val ? moment(val) : val;
      localStorage.filterStartDate = val ? val : "";
      //console.log('filterStartDate',val, typeof val, start, this.startDate)
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {startDate: start});
    },

    filterEndDate(val) {
      if (val === null) this.endDate = null;
      this.$refs.menuEndDate.save(val);
      let end = val ? moment(val) : val;
      localStorage.filterEndDate = val ? val : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {endDate: end});
    },

    filterDoctors(val) {
      //console.log('filterDoctors', val, typeof val)
      localStorage.filterDoctors =
        val && val.length > 0 ? JSON.stringify(val) : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {doctors: val});
    },

    filterStates(val) {
      localStorage.filterStates =
        val && val.length > 0 ? JSON.stringify(val) : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {states: val});
    },

    filterInstitutions(val) {
      localStorage.filterInstitutions =
        val && val.length > 0 ? JSON.stringify(val) : "";
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {institutions: val});
    },
  },
};
</script>

<style lang="scss">
// @import '~vue-context/src/sass/vue-context';
@import "~vue-context/dist/css/vue-context.css";
.badge {
  width: 10px;
  height: 10px;
  display: block;
  &.rounded {
    border-radius: 50%;
  }
}
.v-badge__badge {
  top: 0 !important;
  right: 0 !important;
  .badge-text {
    font-size: 0.8rem;
  }
  .disabled {
    color: rgba(0, 0, 0, 0.26) !important;
  }
}

.line-through {
  text-decoration: line-through;
}
.small-inputs .v-label:not(.v-label--active),
.small-inputs .input {
  font-size: 14px;
}
/* .image {
    width: calc(20% - 10px);
    cursor: pointer;
    margin: 5px;
    display: inline-block;
  } */
</style>
